module.exports = __webpack_public_path__ + "static/media/shot-01.7b2154ae.webp";